import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function Courses(): React.ReactElement {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0)">
        <path d="M14.6154 7.11557H20V4.61557C20 3.02498 18.706 1.73096 17.1154 1.73096H2.88461C1.29402 1.73096 0 3.02498 0 4.61557V15.3848C0 16.9754 1.29402 18.2694 2.88461 18.2694H17.1154C18.706 18.2694 20 16.9754 20 15.3848V12.8848H14.6154C13.0248 12.8848 11.7308 11.5908 11.7308 10.0002C11.7308 8.40959 13.0248 7.11557 14.6154 7.11557Z"/>
        <path d="M14.6155 8.26904C13.6612 8.26904 12.8848 9.04545 12.8848 9.99982C12.8848 10.9542 13.6612 11.7306 14.6155 11.7306H20.0002V8.26908H14.6155V8.26904ZM15.3848 10.5767H14.6155C14.2969 10.5767 14.0386 10.3184 14.0386 9.99982C14.0386 9.68123 14.297 9.42291 14.6155 9.42291H15.3848C15.7034 9.42291 15.9617 9.68123 15.9617 9.99982C15.9617 10.3184 15.7034 10.5767 15.3848 10.5767Z"/>
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="20" height="20" fill="currentColor"/>
        </clipPath>
      </defs>
    </svg>

  );
}

